import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Urgency() {
  return <div className="bg-red-50 border-y border-red-100" data-id="element-295">
      <SectionWrapper className="!py-8 md:!py-12" data-id="element-296">
        <div className="max-w-xl mx-auto text-center" data-id="element-297">
          <div className="inline-flex items-center gap-1.5 bg-red-100 text-red-700 px-3 py-1 rounded-full text-[11px] md:text-sm font-black mb-3 md:mb-4 uppercase tracking-wide ring-1 ring-red-200" data-id="element-298">
            <span data-id="element-299">🔥</span> Última oportunidad
          </div>
          <h2 className="text-[18px] md:text-2xl font-extrabold text-slate-900 mb-4 md:mb-6 tracking-tight" data-id="element-300">
            No dejes que se acaben los cupos
          </h2>

          <div className="bg-white p-4 md:p-5 rounded-2xl border border-red-100 shadow-sm mb-3 md:mb-4 ring-1 ring-slate-900/5" data-id="element-301">
            <div className="flex justify-between text-[12px] md:text-sm font-bold mb-2" data-id="element-302">
              <span className="text-slate-600" data-id="element-303">Cupos restantes</span>
              <span className="text-red-600" data-id="element-304">68% TOMADOS</span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-2.5 md:h-3 overflow-hidden shadow-inner" data-id="element-305">
              <div className="bg-red-500 h-full rounded-full w-[68%]" data-id="element-306"></div>
            </div>
          </div>

          <p className="text-[12px] md:text-sm text-slate-600 font-semibold" data-id="element-307">
            Cuando se acaben los cupos el precio sube y NO vuelve a bajar.
          </p>
        </div>
      </SectionWrapper>
    </div>;
}